const dataTableLanguageUrl = "/js/datatables/sv_SE.json";
const elementName = "#meter-installations-table";
//const filterSelector = "input[type=radio][name=consumption-type-filter]";
let installationsTable = null;

export function initializeInstallationsTable() {
    installationsTable = $(elementName).DataTable({
        language: {url: dataTableLanguageUrl},
        processing: true,
        serverSide: false,
        responsive: true,
        stateSave: true,
        scrollX: true,
        pageLength: 50,
        layout: {
            topStart: [
                'pageLength',
                { buttons: ['excel'] }
            ],
        }
    });
}
